// Auto-generated normalizer for table: Examen
export function examenNormalize(row) {
  return {
    idExamen: row.idExamen ?? row.IdExamen ?? row['IdExamen'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    preguntasAleatorias: row.preguntasAleatorias ?? row.PreguntasAleatorias ?? row['PreguntasAleatorias'] ?? 0,
    limiteIntentos: row.limiteIntentos ?? row.LimiteIntentos ?? row['LimiteIntentos'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
